<template>
  <el-card shadow="hover" style="margin-left: 10px;margin-top: 10px;width: 97%">
    <template #header>
      <div style="font-size: 20px;text-align:center; color: green">您目前的积分为：{{ userInfo.pointCardScore }} &nbsp;&nbsp;&nbsp;&nbsp;
        <el-button type="primary" size="default" @click="openTask()">获取积分</el-button>
        <br>
        <el-link style="font-size: large;color: blue" @click="handleToPage('/fire/MediumFireDeviceHome')">>>免费试用
        </el-link>
      </div>
    </template>
    <el-form :rules="rules" ref="checkOffForm" :model="checkOffForm">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="productInfo" label="产品信息">
            <el-select v-model="checkOffForm.productInfo" style="width: 200px" size="large">
              <el-option v-for="item in productInfos" :key="item.id" :label="item.name"
                         :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="checkOffForm.productInfo.type==='midFire'" prop="finalAreaValue" label="鉴定站">
            <el-cascader
                v-model="checkOffForm.finalAreaValue"
                :options="areaOptions"
                @change="(val) => { areaChange(val)}"
                placeholder="请选择地区"
                size="large"
                ref="cascaderArea"
            ></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">

        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="getExchangeProduct"
                     size="large" style="float:right;margin-left: 10px ">查询可兑换产品
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
  <el-table :data="exchangeProductInfos" title="积分产品信息" max-height="300"
            style="margin-left: 10px;margin-top: 10px;width: 97%">
    <el-table-column prop="name" label="产品名称" width="180px">
    </el-table-column>
    <el-table-column prop="areaName" label="地区">
    </el-table-column>
    <el-table-column prop="period" label="开通时间(分钟)">
    </el-table-column>
    <el-table-column prop="money" label="所需积分">
    </el-table-column>
    <el-table-column label="操作">
      <template #default="scope">
        <el-button size="small" type="primary" @click="pointCardSubmit(scope.row)">兑换</el-button>
      </template>
    </el-table-column>
  </el-table>

  <el-dialog v-model="showSubmitPayDialog" append-to-body style="width: 400px;">
    <div>
      感谢您的信任，您的权益正在生成，<br>
      请用微信扫一扫加入微信群，<br>
      可与志同道合的考友一起学习进步,<br>
      若有问题也可在群里直接联系到管理员。<br>
      <img :src="`/view${productDetailInfo.groupImagePath}`" style="width:300px;height: auto" alt="groupImage"/>
    </div>
    <span class="dialog-footer">
			<el-button type="primary" @click="hasJoin" style="float:right;margin-right: 20px">已加入微信群</el-button>
		</span>
  </el-dialog>

  <el-dialog v-model="showTask" title="获取积分" append-to-body>
    <pointCardTaskComponent></pointCardTaskComponent>
  </el-dialog>

</template>

<script>
import router from "@/router";
import request from "@/utils/request";
import {ElMessage} from "element-plus";
import {ref} from "vue";
import {exchangeProductDetailApi} from "@/utils/productDetailInfoApi";

import pointCardTaskComponent from "@/components/PointCardTask";

const loginNickName = localStorage.getItem("loginNickName");

const loginUserId = localStorage.getItem("loginUserId");
const isBuy = ref(false);
const productInfos = ref([]);
const productType = ref('midFire');
const showSubmitPayDialog = ref(false);
const productDetailInfo = ref('');
const userInfo = ref('');
let exchangeProductInfos = ref([]);
const showTask = ref(false);


async function getUserInfo() {
  await request.get('/userInfo/',
      {
        params: {
          userId: loginUserId,
        }
      }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code === "200") {
      userInfo.value = result.data;
    } else {
      ElMessage.warning(result.msg);
      router.push("/login");
    }
  }).catch(error => {
    console.error("sendPhoneConfirmCode error:" + error);
    // ElMessage.info("系统异常，请联系管理员");
  })
}


async function createBuyPointCardInfo(areaId, productDetailId, platform, productId, money) {
  await request.post('/buyInfo/pointCard', {
    userId: loginUserId,
    areaId: areaId,
    productId: productId,
    platform: platform,
    productDetailId: productDetailId,
    money: money
  })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          ElMessage.info("兑换成功");
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("createBuyPointCardInfo error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

async function getAreaAll() {
  await request.get('/area/all', {
    params: {
      type: "fire"
    }
  }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code === "200") {
      areaOptions.value = result.data;
    } else {
      ElMessage.warning(result.msg);
      router.push("/login");
    }
  }).catch(error => {
    console.log("getAreaAll error:" + error);
    // ElMessage.error("系统异常，请联系管理员");
  });
}

function getUserAuthorization(type) {
  request.get('/userAuthorization/get',
      {
        params: {
          userId: loginUserId, type: type
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          isBuy.value = result.data.length > 0;
          if (isBuy.value) {
            buyAreaOptions.value = Array.from(result.data.reduce((map, item) => {
              const key = item.areaId;
              if (!map.has(key)) {
                map.set(key, {"id": item.areaId, "name": item.areaName});
              }
              return map;
            }, new Map()).values());
            this.buyAreaValue = buyAreaOptions.value[0].id;
          }
        } else {
          ElMessage.warning(result.msg);
          router.push("/login");
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getCascaderObj(val, opt) {
  return val.map(function (value) {
    for (var itm of opt) {
      if (itm.value === value) {
        opt = itm.children;
        return itm;
      }
    }
    return null;
  });
}


async function getProductByStatus() {
  await request.get('/productInfo/', {
    params: {
      status: 'active'
    }
  })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          productInfos.value = result.data;
          this.checkOffForm.productInfo = productInfos.value[0]
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("getProductByAreaId error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}


const areaOptions = ref([]);
const buyAreaOptions = ref([]);
const finalAreaValue = ref('');
const finalAreaLabel = ref('');
const productDetailTypes = ref([]);
const productInfo = ref('');
const userAccountStartTime = ref('');
const userAccountEndTime = ref('');

export default {
  name: "PointCardExchange",
  components: {pointCardTaskComponent},
  async created() {
    await getUserInfo();
    await getAreaAll();
    await getProductByStatus.call(this);
    if (loginUserId !== null && loginUserId !== '') {
      getUserAuthorization.call(this, "subject");
    }
  },
  data() {
    return {
      loginNickName: loginNickName,
      areaOptions: areaOptions,
      buyAreaValue: '',
      buyAreaOptions: buyAreaOptions,
      finalAreaValue: finalAreaValue,
      productInfos: productInfos,
      productType: productType,
      productDetailTypes: productDetailTypes,
      finalAreaLabel: finalAreaLabel,
      userAccountStartTime: userAccountStartTime,
      userAccountEndTime: userAccountEndTime,
      checkOffForm: {
        productInfo: productInfo,
        finalAreaValue: finalAreaValue
      },
      rules: {
        productInfo: [{required: true, message: "请选择产品", trigger: "blur"}],
        finalAreaValue: [{required: true, message: "请选择鉴定站", trigger: "blur"}]
      },
      showSubmitPayDialog: showSubmitPayDialog,
      productDetailInfo: productDetailInfo,
      userInfo: userInfo,
      exchangeProductInfos: exchangeProductInfos,
      showTask: showTask
    }
  },
  methods: {
    handleToPage(path) {
      router.push(path);
    },
    areaChange(value) {
      if (value && value.length) {
        finalAreaValue.value = value[value.length - 1];
        finalAreaLabel.value = getCascaderObj(value, this.areaOptions)[1].label;
      }
    },
    pointCardSubmit(productDetailItem) {
      if (userInfo.value.pointCardScore < productDetailItem.money) {
        ElMessage.error("用户积分小于产品可兑换积分，请获取足够积分后再兑换");
        return;
      }
      this.$confirm(`确定兑换<span style="color: blue;">${finalAreaLabel.value} ${this.checkOffForm.productInfo.name}</span>?<br>
<div style="font-size: 14px">注意:<br>不限制设备个数，但同一时间只能有一台设备在线学习,切换设备需重新登录。<br>此为虚拟物品,发货后不退不换，请试用后再购买。<br>
请核查确认购买的鉴定站：<span style="color: red;">${finalAreaLabel.value}</span>是否正确,<span style="color: orangered;">购买后无法更改鉴定站</span><br>
<span>兑换成功后账号付费后的功能将立刻生效，若多次兑换，账户有效期将依次顺延</span>`,
          '', {
            confirmButtonText: '确定兑换',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning',
            customClass: 'confirmBox'

          }).then(async () => {
        ElMessage.info("正在兑换");
        productDetailInfo.value = productDetailItem;
        // 确认操作的代码
        await createBuyPointCardInfo.call(this, finalAreaValue.value, productDetailItem.id, "pointCard", this.checkOffForm.productInfo.id, productDetailItem.money);

        showSubmitPayDialog.value = true;
      });
    },
    hasJoin() {
      showSubmitPayDialog.value = false;
      router.push({
        path: "/userInfo/userInfoHome"
      });
    },
    async getExchangeProduct() {
      if (userInfo.value.pointCardScore < 30) {
        ElMessage.error("积分小于最低可兑换的积分，请获取积分后再兑换");
        return;
      }
      this.$refs.checkOffForm.validate(async (valid) => {
        if (valid) {
          exchangeProductDetailApi(loginUserId, finalAreaValue.value, this.checkOffForm.productInfo.id).then(response => {
            if (response.code === "200") {
              exchangeProductInfos.value = response.data;
            } else {
              ElMessage.warning(response.msg);
            }
          });
        }
      });

    },
    openTask() {
      showTask.value = true;
    }
  }
}
</script>

<style scoped>
.el-cascader-panel {
  font-size: 16px !important;
}

.confirmBox {
  width: 400px;
}

.el-message-box {
  width: 400px !important;
}
</style>
